import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import EmptyLayout from './EmptyLayout'
import { Spinner } from '@verisart/shared'
import LoginFlow from '../components/organisms/Login/LoginFlow'
import { useAPI } from 'src/context/api'

const RootLayout = () => {
  const location = useLocation()
  const { initialized, hasSession, shopDomain, email } = useAPI()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  if (initialized && !shopDomain) {
    return <p>Error: No shop specified!</p>
  }

  if (!initialized) {
    return (
      <EmptyLayout>
        <div className="ver-w-full ver-text-center">
          <Spinner />
        </div>
      </EmptyLayout>
    )
  }

  if (!hasSession) {
    return <LoginFlow email={email || null} />
  }

  return <Outlet />
}

export default RootLayout
